import React from 'react';

export const SortIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16px"
    height="15px"
    viewBox="0 0 16 15"
    style={{
      fillRule: 'nonzero',
    }}
    {...props}
  >
    <g>
      <path d="M3.88571429,14.5838608 L3.88571429,1.3306962 L6.28897959,3.65981013 C6.36734694,3.73575949 6.46857143,3.77373418 6.57306122,3.77373418 C6.67755102,3.77373418 6.77877551,3.73575949 6.85714286,3.65981013 C7.01387755,3.50791139 7.01387755,3.26424051 6.85714286,3.11234177 L3.77142857,0.121835443 C3.62122449,-0.0237341772 3.35673469,-0.0237341772 3.20653061,0.121835443 L0.11755102,3.11234177 C-0.0391836735,3.26424051 -0.0391836735,3.50791139 0.11755102,3.65981013 C0.274285714,3.81170886 0.525714286,3.81170886 0.68244898,3.65981013 L3.08571429,1.3306962 L3.08571429,14.5838608 C3.08571429,14.7990506 3.26530612,14.9731013 3.48734694,14.9731013 C3.70612245,14.9699367 3.88571429,14.7958861 3.88571429,14.5838608 Z"/>
      <path d="M12.2057143,14.8560127 C12.2840816,14.931962 12.3853061,14.9699367 12.4897959,14.9699367 C12.5942857,14.9699367 12.6955102,14.931962 12.7738776,14.8560127 L15.8595918,11.8655063 C16.0163265,11.7136076 16.0163265,11.4699367 15.8595918,11.318038 C15.7028571,11.1661392 15.4514286,11.1661392 15.2946939,11.318038 L12.8914286,13.6471519 L12.8914286,0.393987342 C12.8914286,0.178797468 12.7118367,0.00474683544 12.4897959,0.00474683544 C12.2677551,0.00474683544 12.0881633,0.178797468 12.0881633,0.393987342 L12.0881633,13.6471519 L9.68816327,11.318038 C9.53142857,11.1661392 9.28,11.1661392 9.12326531,11.318038 C8.96653061,11.4699367 8.96653061,11.7136076 9.12326531,11.8655063 L12.2057143,14.8560127 Z"/>
    </g>
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/sort-icon.js